const onGeneratePdf = ( status ) => {

    switch ( status ) {
        case 404:
            return {
                status: status,
                message: "generare il pdf commessa: la commessa non esiste",
            }    
        case 422:
            return {
                status: status,
                message: "generare il pdf commessa: parametri di richiesta non validi.",
            } 
        default:
            return null;
    }

}

export default onGeneratePdf;